import React from 'react'
import {IconButton} from '@mui/material'
import SentimentSatisfiedAlt from '@mui/icons-material/SentimentSatisfiedAlt'
import SentimentDissatisfied from '@mui/icons-material/SentimentDissatisfied'
import {useSessionControls} from './SessionContext'

export default function SynchronizationIndicator() {
  const {session, status, syncStatus, retry} = useSessionControls()
  if (!session) return null
  const synced = syncStatus === 'Synced'
  const color = synced ? 'success.main' : 'error.main'
  return <IconButton aria-label={synced ? 'Synced' : 'Unsynced—click to retry'}
    disabled={synced || status !== 'Hosting'} onClick={() => {void retry()}}
    sx={{color, '&.Mui-disabled': {color}, minWidth: 44, minHeight: 44}}>
    {synced ? <SentimentSatisfiedAlt titleAccess="Happy face"/> : <SentimentDissatisfied titleAccess="Sad face"/>}
  </IconButton>
}
